import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {StyledMailerWrapper} from './style'
import {MailerForm} from '@/features/mailer/components/mailer-form/MailerForm'

export const Mailer = () => {
    const {t} = useTranslation()

    return (
        <StyledMailerWrapper>
            <Helmet title={t('mailer:title')} />
            <PageHeading>
                <h2>{t('mailer:title')}</h2>
            </PageHeading>
            <MailerForm />
        </StyledMailerWrapper>
    )
}
